<div odxLayout="flex gap-small" class="w-100 h-100">
  <div odxLayout="flex gap-none" class="flex-column project-menu">
    <app-floorplan-menu-button
      [expanded]="expanded"
      [title]="expanded ? textHideMenu : textShowMenu"
      odxVariant="ghost"
      [odxIcon]="expanded ? 'chevron-left' : 'chevron-right'"
      (click)="expanded = !expanded"
      data-testid="floorplanMenu.btn.collapseMenu"
    >
    </app-floorplan-menu-button>
    <app-floorplan-menu-button
      [expanded]="expanded"
      [title]="FloorplanMenuType.MAIN_SETTINGS | localizeFloorplanMenuType"
      odxVariant="ghost"
      odxIcon="tile-menu"
      (click)="open(FloorplanMenuType.MAIN_SETTINGS)"
      data-testid="floorplanMenu.btn.mainMenu"
    >
    </app-floorplan-menu-button>
    @if (userScope === BusinessScope.FGDS) {
      <app-floorplan-menu-button
        [expanded]="expanded"
        [title]="FloorplanMenuType.PRODUCT_SEARCH | localizeFloorplanMenuType"
        odxVariant="ghost"
        odxIcon="search"
        (click)="open(FloorplanMenuType.PRODUCT_SEARCH)"
        data-testid="floorplanMenu.btn.productSearch"
      >
      </app-floorplan-menu-button>
    }
    @if (userScope === BusinessScope.MONITORING) {
      <app-floorplan-menu-button
        [expanded]="expanded"
        [title]="FloorplanMenuType.MONITORING_PRODUCT_SEARCH | localizeFloorplanMenuType"
        odxVariant="ghost"
        odxIcon="search"
        (click)="open(FloorplanMenuType.MONITORING_PRODUCT_SEARCH)"
        data-testid="floorplanMenu.btn.monitoringProductSearch"
      >
      </app-floorplan-menu-button>
    }

    <app-floorplan-menu-button
      [expanded]="expanded"
      [title]="FloorplanMenuType.GROUP | localizeFloorplanMenuType"
      imageUrl="../../assets/floorplan-menu-icons/gruppe_menu.svg"
      (click)="open(FloorplanMenuType.GROUP)"
      data-testid="floorplanMenu.btn.group"
    >
    </app-floorplan-menu-button>
    @if (userScope === BusinessScope.FGDS) {
      <app-floorplan-menu-button
        [expanded]="expanded"
        [title]="FloorplanMenuType.GAS_WARNING_CENTER | localizeFloorplanMenuType"
        imageUrl="../../assets/floorplan-menu-icons/gaswarnzentrale_menu.svg"
        (click)="open(FloorplanMenuType.GAS_WARNING_CENTER)"
        data-testid="floorplanMenu.btn.gasWarningCenters"
      >
      </app-floorplan-menu-button>
      <app-floorplan-menu-button
        [expanded]="expanded"
        [title]="FloorplanMenuType.TRANSMITTER | localizeFloorplanMenuType"
        imageUrl="../../assets/floorplan-menu-icons/transmitter_menu.svg"
        (click)="open(FloorplanMenuType.TRANSMITTER)"
        data-testid="floorplanMenu.btn.transmitters"
      >
      </app-floorplan-menu-button>
      <app-floorplan-menu-button
        [expanded]="expanded"
        [title]="FloorplanMenuType.FLAME_DETECTOR | localizeFloorplanMenuType"
        imageUrl="../../assets/floorplan-menu-icons/flame_detector_menu.svg"
        (click)="open(FloorplanMenuType.FLAME_DETECTOR)"
        data-testid="floorplanMenu.btn.flameDetectors"
      >
      </app-floorplan-menu-button>
      <app-floorplan-menu-button
        [expanded]="expanded"
        [title]="FloorplanMenuType.SIGNAL_ELEMENT | localizeFloorplanMenuType"
        imageUrl="../../assets/floorplan-menu-icons/leuchttransparent_menu.svg"
        (click)="open(FloorplanMenuType.SIGNAL_ELEMENT)"
        data-testid="floorplanMenu.btn.signalElements"
      >
      </app-floorplan-menu-button>
      <app-floorplan-menu-button
        [expanded]="expanded"
        [title]="FloorplanMenuType.PLASTIC_SIGN | localizeFloorplanMenuType"
        imageUrl="../../assets/floorplan-menu-icons/kunststoffschild_menu.svg"
        (click)="open(FloorplanMenuType.PLASTIC_SIGN)"
        data-testid="floorplanMenu.btn.plasticSigns"
      >
      </app-floorplan-menu-button>
      <app-floorplan-menu-button
        [expanded]="expanded"
        [title]="FloorplanMenuType.ALARM_DEVICE | localizeFloorplanMenuType"
        imageUrl="../../assets/floorplan-menu-icons/alarmmittel_menu.svg"
        (click)="open(FloorplanMenuType.ALARM_DEVICE)"
        data-testid="floorplanMenu.btn.alarmDevices"
      >
      </app-floorplan-menu-button>
      <app-floorplan-menu-button
        [expanded]="expanded"
        [title]="FloorplanMenuType.ZONE | localizeFloorplanMenuType"
        imageUrl="../../assets/floorplan-menu-icons/zone_menu.svg"
        (click)="open(FloorplanMenuType.ZONE)"
        data-testid="floorplanMenu.btn.mainMenu"
      >
      </app-floorplan-menu-button>
      <app-floorplan-menu-button
        [expanded]="expanded"
        [title]="FloorplanMenuType.IMAGE | localizeFloorplanMenuType"
        odxIcon="camera"
        (click)="open(FloorplanMenuType.IMAGE)"
        data-testid="floorplanMenu.btn.images"
      >
      </app-floorplan-menu-button>
      <app-floorplan-menu-button
        [expanded]="expanded"
        [title]="FloorplanMenuType.WIRING | localizeFloorplanMenuType"
        imageUrl="../../assets/floorplan-menu-icons/rohrleitung_menu.svg"
        (click)="open(FloorplanMenuType.WIRING)"
        data-testid="floorplanMenu.btn.wiring"
      >
      </app-floorplan-menu-button>
      <app-floorplan-menu-button
        [expanded]="expanded"
        [title]="FloorplanMenuType.AIR_PATH | localizeFloorplanMenuType"
        odxIcon="arrow-right"
        (click)="open(FloorplanMenuType.AIR_PATH)"
        data-testid="floorplanMenu.btn.airPaths"
      >
      </app-floorplan-menu-button>
      <app-floorplan-menu-button
        [expanded]="expanded"
        [title]="FloorplanMenuType.ANNOTATION | localizeFloorplanMenuType"
        imageUrl="../../assets/floorplan-menu-icons/notiz_menu.svg"
        (click)="open(FloorplanMenuType.ANNOTATION)"
        data-testid="floorplanMenu.btn.notes"
      >
      </app-floorplan-menu-button>
      <app-floorplan-menu-button
        [expanded]="expanded"
        [title]="FloorplanMenuType.DIMENSIONS | localizeFloorplanMenuType"
        imageUrl="../../assets/floorplan-menu-icons/bemassung_menu.svg"
        (click)="open(FloorplanMenuType.DIMENSIONS)"
        data-testid="floorplanMenu.btn.measurements"
      >
      </app-floorplan-menu-button>
    } @else if (userScope === BusinessScope.MONITORING) {
      <app-floorplan-menu-button
        [expanded]="expanded"
        [title]="FloorplanMenuType.MONITORING_PATIENT_MONITOR | localizeFloorplanMenuType"
        imageUrl="../../assets/floorplan-menu-icons/patient_monitor_menu.svg"
        (click)="open(FloorplanMenuType.MONITORING_PATIENT_MONITOR)"
        data-testid="floorplanMenu.btn.patientMonitors"
      >
      </app-floorplan-menu-button>
      <app-floorplan-menu-button
        [expanded]="expanded"
        [title]="FloorplanMenuType.MONITORING_CENTRAL_STATION | localizeFloorplanMenuType"
        imageUrl="../../assets/floorplan-menu-icons/central_station_menu.svg"
        (click)="open(FloorplanMenuType.MONITORING_CENTRAL_STATION)"
        data-testid="floorplanMenu.btn.centralStations"
      >
      </app-floorplan-menu-button>
      <app-floorplan-menu-button
        [expanded]="expanded"
        [title]="FloorplanMenuType.MONITORING_TELEMETRY | localizeFloorplanMenuType"
        imageUrl="../../assets/floorplan-menu-icons/telemetry_menu.svg"
        (click)="open(FloorplanMenuType.MONITORING_TELEMETRY)"
        data-testid="floorplanMenu.btn.telemetries"
      >
      </app-floorplan-menu-button>
      <app-floorplan-menu-button
        [expanded]="expanded"
        [title]="FloorplanMenuType.MONITORING_KVM | localizeFloorplanMenuType"
        imageUrl="../../assets/floorplan-menu-icons/kvm_menu.svg"
        (click)="open(FloorplanMenuType.MONITORING_KVM)"
        data-testid="floorplanMenu.btn.kvms"
      >
      </app-floorplan-menu-button>
      <app-floorplan-menu-button
        [expanded]="expanded"
        [title]="FloorplanMenuType.MONITORING_DISPLAY | localizeFloorplanMenuType"
        imageUrl="../../assets/floorplan-menu-icons/display_menu.svg"
        (click)="open(FloorplanMenuType.MONITORING_DISPLAY)"
        data-testid="floorplanMenu.btn.displays"
      >
      </app-floorplan-menu-button>
      <app-floorplan-menu-button
        [expanded]="expanded"
        [title]="FloorplanMenuType.MONITORING_UTILITY | localizeFloorplanMenuType"
        imageUrl="../../assets/floorplan-menu-icons/utility_menu.svg"
        (click)="open(FloorplanMenuType.MONITORING_UTILITY)"
        data-testid="floorplanMenu.btn.utilities"
      ></app-floorplan-menu-button>
      <app-floorplan-menu-button
        [expanded]="expanded"
        [title]="FloorplanMenuType.ZONE | localizeFloorplanMenuType"
        imageUrl="../../assets/floorplan-menu-icons/zone_menu.svg"
        (click)="open(FloorplanMenuType.MONITORING_ZONE)"
        data-testid="floorplanMenu.btn.mainMenu"
      >
      </app-floorplan-menu-button>
      <app-floorplan-menu-button
        [expanded]="expanded"
        [title]="FloorplanMenuType.IMAGE | localizeFloorplanMenuType"
        odxIcon="camera"
        (click)="open(FloorplanMenuType.IMAGE)"
        data-testid="floorplanMenu.btn.images"
      >
      </app-floorplan-menu-button>
      <app-floorplan-menu-button
        [expanded]="expanded"
        [title]="FloorplanMenuType.ANNOTATION | localizeFloorplanMenuType"
        imageUrl="../../assets/floorplan-menu-icons/notiz_menu.svg"
        (click)="open(FloorplanMenuType.ANNOTATION)"
        data-testid="floorplanMenu.btn.notes"
      >
      </app-floorplan-menu-button>
      <app-floorplan-menu-button
        [expanded]="expanded"
        [title]="FloorplanMenuType.DIMENSIONS | localizeFloorplanMenuType"
        imageUrl="../../assets/floorplan-menu-icons/bemassung_menu.svg"
        (click)="open(FloorplanMenuType.DIMENSIONS)"
        data-testid="floorplanMenu.btn.measurements"
      >
      </app-floorplan-menu-button>
    }
  </div>
  <div>
    @if (selectedMenu !== undefined && activeFloorplan) {
      <app-floorplan-menu-item
        [activeFloorplan]="activeFloorplan"
        [menuType]="selectedMenu"
        (close$)="close()"
      ></app-floorplan-menu-item>
    }
  </div>
</div>
